<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a1" id="ack1"><a href="#/Text/contents#ack">ACKNOWLEDGMENTS</a></h2>
<p class="center1-o"><span>My thanks to Dr. Marjory Foyle and Dr. Debbie Lovell-Hawker<br/>
  for their input and encouragement.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgements.vue?ee05f6f4